module.exports = __webpack_public_path__ + "media/images/pepsi_digin_brunch_lv/food-img-98dde575dfb5ba56029234cc36a5dc59.png";